import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { CommitteeDocument, CommitteeDocumentListResponse } from '../models/documents';

export const onGetCommitteeDocumentsList = async (committeeId: number, page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeDocumentListResponse>>(`dashboard/committees/${committeeId}/committee-documents`, {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeDocumentById = async (committeeId: string, documentId: string) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeDocument>>(`dashboard/committees/${committeeId}/committee-documents/${documentId}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateCommitteeDocument = async (committeeId: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<CommitteeDocument>>(`dashboard/committees/${committeeId}/committee-documents`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateCommitteeDocument = async (committeeId: string, documentId: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<CommitteeDocument>>(
			`dashboard/committees/${committeeId}/committee-documents/${documentId}`,
			payload,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteCommitteeDocument = async (committeeId: string, documentId: string) => {
	try {
		const response = await axios.delete(`dashboard/committees/${committeeId}/committee-documents/${documentId}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
